/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Request } from 'express'

/** Default key generator: real client IP, proxy-aware via X-Forwarded-For. */
export const extractIp = (req: Request): string => {
  const fwd = req.headers['x-forwarded-for'] as string | undefined
  if (fwd) return fwd.split(',')[0]!.trim()
  return req.ip ?? req.socket?.remoteAddress ?? 'unknown'
}

/**
 * User-scoped key: `user:<id>` when `req.user` is set by auth middleware,
 * otherwise falls back to `ip:<address>`.
 */
export const buildUserKey = (req: Request): string => {
  const user = (req as any).user as Record<string, unknown> | undefined
  const userId: unknown = user?.['id'] ?? user?.['_id']
  if (userId != null) return `user:${String(userId)}`
  const fwd = req.headers['x-forwarded-for'] as string | undefined
  if (fwd) return `ip:${fwd.split(',')[0]!.trim()}`
  return `ip:${req.ip ?? req.socket?.remoteAddress ?? 'unknown'}`
}
